module.exports = __webpack_public_path__ + "img/total.884be58b.png";